import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('attributes');
const type = createActionType('attributes');

export const LOAD_ATTRIBUTE_DEFINITIONS = apiType('LoadAttributeDefinitions');
export const CREATE_ATTRIBUTE_DEFINITION = apiType('CreateAttributeDefinition');
export const UPDATE_ATTRIBUTE_DEFINITION = apiType('UpdateAttributeDefinition');
export const DELETE_ATTRIBUTE_DEFINITION = apiType('DeleteAttributeDefinition');

export const SET_ATTRIBUTE_VALUE = apiType('SetAttributeValue');
export const DELETE_ATTRIBUTE_VALUE = apiType('DeleteAttributeValue');

export const OPEN_DIALOG = type('OpenDialog');
export const CLOSE_DIALOG = type('CloseDialog');
